export const DOMAIN_CLIENT = "https://www.tcs.com.vn/api/";
export const IMAGES_URL = "https://www.tcs.com.vn/api/images/";
